import { CaretRight, Storefront } from '@phosphor-icons/react'
import { HoverCard, HoverCardContent, HoverCardTrigger, Icon } from '@shopflo/ui'
import { motion, AnimatePresence } from 'motion/react'
import { useState } from 'react'
import StoreList from './StoreList'
import { useLocale } from 'src/lib/hooks/useLocal'

const StoreSelector = () => {
  const { t } = useLocale()
  const [isOpen, setIsOpen] = useState(false)

  return (
    <HoverCard openDelay={300} closeDelay={300} open={isOpen} onOpenChange={setIsOpen}>
      <HoverCardTrigger asChild>
        <div
          className='flex items-center justify-between px-2 py-1.5 hover:bg-zinc-100 rounded-md cursor-pointer'
          onClick={() => setIsOpen(true)}
        >
          <div className='flex items-center gap-2'>
            <div className='w-5 h-5 flex items-center justify-center'>
              <Storefront size={18} className='text-zinc-500' />
            </div>
            <p className='text-zinc-600 text-text-sm-regular'>{t('navigation.all_stores')}</p>
          </div>
          <motion.div transition={{ duration: 0.1, ease: 'easeOut' }}>
            <Icon IconComponent={CaretRight} size='xs' className='text-zinc-500' />
          </motion.div>
        </div>
      </HoverCardTrigger>
      <AnimatePresence>
        <HoverCardContent
          side='right'
          align='start'
          sideOffset={8}
          className='bg-white w-64 p-0 !border-none !rounded-xl'
          asChild
        >
          <div className='overflow-y-auto'>
            <StoreList />
          </div>
        </HoverCardContent>
      </AnimatePresence>
    </HoverCard>
  )
}

export default StoreSelector
